import { ANWBBrandRefreshTheme } from './themes/anwb-brand-refresh-theme.generated';
export const ANWBBrandRefresh = Object.assign({ name: 'ANWB brand refresh' }, ANWBBrandRefreshTheme);
